import { useState, useEffect } from 'react';
import Toaster from '../designSystem/b-molecules/toaster/Toaster';

/**
 * Version update notification toast component
 * @param {boolean} show - Whether to show the notification
 * @param {Function} onRefresh - Callback when user clicks refresh
 * @param {Function} onDismiss - Callback when user dismisses the notification
 * @param {string} newVersion - The new version number (optional, for display)
 */
const VersionUpdateToast = ({ show, onRefresh, onDismiss, newVersion }) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);
  }, [show]);

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      // Default behavior: reload the page
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <Toaster
      show={isVisible}
      onClose={handleDismiss}
      position="bottom"
      message={
        newVersion
          ? `A new version (${newVersion}) is available. Refresh to get the latest features and fixes.`
          : 'A new version is available. Refresh to get the latest features and fixes.'
      }
      actions={[
        {
          name: 'Refresh',
          onClick: handleRefresh,
          variants: []
        }
      ]}
      showCloseButton={true}
    />
  );
};

export default VersionUpdateToast;

